import { render, staticRenderFns } from "./text-only-modal.vue?vue&type=template&id=39302b18&"
import script from "./text-only-modal.vue?vue&type=script&lang=js&"
export * from "./text-only-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports